import React, { useState } from 'react';
import './Misiuni.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faCheckCircle, faTrophy, faFlagCheckered } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp, faHeart } from '@fortawesome/free-solid-svg-icons';
import StatsCard from '../popupsright/StatsCard';
import GetProCard from '../rightelements/GetProCard';
import MotivationalMission from '../rightelements/MotivationalMission';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import './reglaredimensiune.css';



const duolingoMissions = [
  {
    text: 'Castiga 300 XP',
    progress: 120,
    total: 300,
    icon: faTrophy,
  },
  {
    text: 'Completeaza 3 lectii',
    progress: 3,
    total: 3,
    icon: faBookOpen,
  },
  {
    text: 'Rezolva 5 aplicatii',
    progress: 2,
    total: 5,
    icon: faCheckCircle,
  },
];

const learningQuotes = [
  "Maiestria vine celor care persevereaza, nu celor care nu gresesc niciodata.",
  "Invatarea constanta construieste incredere reala.",
  "Progresul mic, repetat zilnic, produce rezultate mari.",
  "Fiecare greseala este un pas spre intelegere.",
  "Disciplina valoreaza mai mult decat motivatia.",
  "Ceea ce exersezi zilnic devine competenta ta.",
  "Succesul nu vine rapid, vine constant.",
  "Invata astazi pentru claritate maine.",
  "Consecventa transforma efortul in expertiza.",
  "Nu renunta. Fiecare intrebare rezolvata conteaza."
];



const Misiuni = () => {
  const [missions] = useState(duolingoMissions);

  const [quoteOpen, setQuoteOpen] = useState(false);

  const [randomQuote] = useState(
  learningQuotes[Math.floor(Math.random() * learningQuotes.length)]
);



  return (
    <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>
    <div className="componentsmenu-container">
        <StatsCard />
        
      <div className="missions-card">
        <div className="missions-title">Misiuni zilnice</div>

        <div className="missions-list">
          {missions.map((mission, index) => {
            const percent = Math.round((mission.progress / mission.total) * 100);
            const isCompleted = percent === 100;

            return (
              <div
                key={index}
                className={`mission-item ${isCompleted ? 'mission-completed' : ''}`}
              >
                <div className="mission-header">
                  <div className="mission-text">{mission.text}</div>

                  <div className="mission-right">
                    <span className="mission-percent">{percent}%</span>
                    <FontAwesomeIcon
                      icon={faFlagCheckered}
                      className="mission-flag"
                    />
                  </div>
                </div>

                <div className="mission-progress-bar">
                  <div
                    className="mission-progress-fill"
                    style={{ width: `${percent}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

<div className="quote-card">
  <div
    className="quote-header"
    onClick={() => setQuoteOpen(!quoteOpen)}
  >
    <div>
      <div className="quote-title">Ramai motivat!</div>
      <div className="quote-date">Saptamana 8, 2026</div>
    </div>

    <FontAwesomeIcon
      icon={faChevronUp}
      className={`quote-toggle ${!quoteOpen ? "rotated" : ""}`}
    />
  </div>

  {quoteOpen && (
    <>
      <div className="quote-text">
        "{randomQuote}"
      </div>


      <div className="quote-footer">
        <div className="quote-author">
          ContaLearn AI
        </div>

        <div className="quote-likes">
          639 <FontAwesomeIcon icon={faHeart} />
        </div>
      </div>
    </>
  )}
</div>


    </div>

    <div className="right-elements-componentsmenu">
      <GetProCard />
      <MotivationalMission />
      <FooterElements />
      <SocialElements />
     

    </div>

    </div>
  );
};

export default Misiuni;
